// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_members_model from "./web_members_model.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function form(model) {
  return Stdlib__Option.fold(Mapre_web__Web_members_model.initial, (function (f) {
    return f.members;
  }), model.invitation_form);
}

function action(send, value) {
  const partial_arg = {
    TAG: /* Invitations */ 48,
    _0: {
      TAG: /* Members */ 9,
      _0: value
    }
  };
  return function (param) {
    return Lui_elements.press(send, partial_arg, param);
  };
}

function controls(locked, member, send) {
  const roles = Stdlib__List.map((function (role) {
    return function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___001_) {
        const partial_arg = (function ($$event) {
          action(send, {
            TAG: /* Change */ 0,
            _0: Signal.sample(member),
            _1: role
          })($$event);
        });
        const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map2((function (locked, i) {
          if (locked) {
            return true;
          } else {
            return i.role === role;
          }
        }), locked, member)));
        const partial_arg$2 = "outline";
        const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (i) {
          return "Set " + (i.login + (" to " + role));
        }), member)));
        return function (param, param$1) {
          return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    };
  }), {
    hd: "viewer",
    tl: {
      hd: "member",
      tl: {
        hd: "admin",
        tl: /* [] */ 0
      }
    }
  });
  const remove = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___002_) {
      const partial_arg = (function ($$event) {
        action(send, {
          TAG: /* Remove */ 1,
          _0: Signal.sample(member)
        })($$event);
      });
      const partial_arg$1 = Caml_option.some(locked);
      const partial_arg$2 = "ghost";
      const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (i) {
        return "Remove " + i.login;
      }), member)));
      return function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg = Stdlib.$at(roles, {
    hd: remove,
    tl: /* [] */ 0
  });
  const partial_arg$1 = "wrap";
  const partial_arg$2 = 8;
  return function (param, param$1) {
    return Lui_elements.row(undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, partial_arg, param, param$1);
  };
}

function confirmation(source, send) {
  const partial_arg = action(send, /* Cancel */ 3);
  const partial_arg$1 = "ghost";
  const partial_arg$2 = "Cancel removal";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___004_) {
      const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (m) {
        return Stdlib__Option.fold("", (function (i) {
          return "Remove " + (i.login + "? Their open sessions and execution access will be revoked.");
        }), form(m).confirm);
      }), source)));
      return function (param, param$1) {
        return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___005_) {
        const partial_arg = action(send, /* Confirm */ 2);
        const partial_arg$1 = "primary";
        const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (m) {
          return Stdlib__Option.fold("Confirm removal", (function (i) {
            return "Confirm removal of " + i.login;
          }), form(m).confirm);
        }), source)));
        return function (param, param$1) {
          return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      }),
      tl: /* [] */ 0
    }
  };
  const partial_arg$3 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$4 = 8;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, param, param$1);
  };
}

function view(source, send) {
  const partial_arg = "Workspace members";
  const partial_arg$1 = 2;
  const partial_arg$2 = Signal.map((function (m) {
    return form(m).rows;
  }), source);
  const partial_arg$3 = confirmation(source, send);
  const partial_arg$4 = Signal.map((function (m) {
    return form(m).confirm !== undefined;
  }), source);
  const partial_arg$5 = action(send, /* Retry */ 4);
  const partial_arg$6 = "primary";
  const partial_arg$7 = "Retry member change";
  const partial_arg$8 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$9 = Signal.map((function (m) {
    if (form(m).pending !== undefined) {
      return !form(m).busy;
    } else {
      return false;
    }
  }), source);
  const partial_arg$10 = Signal.map((function (m) {
    return form(m).cursor !== undefined;
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.keyed(partial_arg$2, (function (i) {
        return i.user_id;
      }), Stdlib__String.compare, (function (param) {
        const locked = Signal.map((function (m) {
          const f = form(m);
          if (f.busy || f.loading || f.pending !== undefined) {
            return true;
          } else {
            return !Mapre_web__Web_model.can_manage_members(m);
          }
        }), source);
        const partial_arg = controls(locked, param, send);
        const partial_arg$1 = Signal.map((function (i) {
          return i.role !== "owner";
        }), param);
        const partial_arg_0 = function (param$1, param$2) {
          return Lui_elements.scoped((function (__lui_context___003_) {
            const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (i) {
              return i.login + (" / " + i.role);
            }), param)));
            return function (param, param$1) {
              return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }), param$1, param$2);
        };
        const partial_arg_1 = {
          hd: (function (param, param$1) {
            return Lui_elements.if_(partial_arg$1, partial_arg, param, param$1);
          }),
          tl: /* [] */ 0
        };
        const partial_arg$2 = {
          hd: partial_arg_0,
          tl: partial_arg_1
        };
        const partial_arg$3 = 8;
        const partial_arg$4 = 4;
        return function (param, param$1) {
          return Lui_elements.column(undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$4, partial_arg$3, param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.scoped((function (__lui_context___006_) {
            const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___006_.ui_scope, Signal.map((function (m) {
              return form(m).message;
            }), source)));
            const partial_arg$1 = "notice";
            return function (param, param$1) {
              return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }), param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.if_(partial_arg$9, partial_arg$8, param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.if_(partial_arg$10, (function (param, param$1) {
                return Lui_elements.scoped((function (__lui_context___007_) {
                  const partial_arg = action(send, /* More */ 1);
                  const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___007_.ui_scope, Signal.map((function (m) {
                    const f = form(m);
                    if (f.loading || f.busy) {
                      return true;
                    } else {
                      return f.pending !== undefined;
                    }
                  }), source)));
                  const partial_arg$2 = "ghost";
                  const partial_arg$3 = "More members";
                  return function (param, param$1) {
                    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  };
                }), param, param$1);
              }), param, param$1);
            }),
            tl: {
              hd: (function (param, param$1) {
                return Lui_elements.scoped((function (__lui_context___008_) {
                  const partial_arg = action(send, /* Refresh */ 0);
                  const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___008_.ui_scope, Signal.map((function (m) {
                    const f = form(m);
                    if (f.busy) {
                      return true;
                    } else {
                      return f.pending !== undefined;
                    }
                  }), source)));
                  const partial_arg$2 = "ghost";
                  const partial_arg$3 = "Refresh members";
                  return function (param, param$1) {
                    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  };
                }), param, param$1);
              }),
              tl: /* [] */ 0
            }
          }
        }
      }
    }
  };
  const partial_arg$11 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$12 = 8;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$11, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
